<template>
    <b-form-group :label="label">
        <validation-provider :name="name" :rules="rules" v-slot="{ errors }">
            <b-form-input
                v-model="localValue"
                :placeholder="placeholder"
                :type="type"
            />
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
    name: 'ValidatedInput',
    components: { ValidationProvider, BFormGroup, BFormInput },
    props: {
        label: String,
        name: { type: String, required: true },
        rules: { type: String, default: '' },
        placeholder: String,
        value: [String, Number],
        type: { type: String, default: 'text' }
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>